import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contabilidad } from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { ContabilidadService } from '@p-p-portafolio/promociones/services/contabilidad.service';
import { MatDialog } from '@angular/material/dialog';
import { SwalService } from '@shared/utils/swal.service';
import { ContabilidadFormComponent } from './contabilidad-form/contabilidad-form.component';
import { Table } from 'primeng/table';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contabilidad-promocion',
  templateUrl: './contabilidad-promocion.component.html',
  styleUrls: ['./contabilidad-promocion.component.css']
})
export class ContabilidadPromocionComponent implements OnInit {
  @ViewChild('dt') dt!: Table;
  
  columns = [
    { field: 'let_origen', header: 'Origen' },
    { field: 'let_tipomov', header: 'Movimiento' },
    { field: 'iConcepto', header: 'Concepto' },
    { field: 'desConcepto', header: 'Descripción' },
    { field: 'iSubConcepto', header: 'Sub Concepto' },
    { field: 'descSub', header: 'Descripción' },
    { field: 'sCuenta', header: 'Cuenta' },
    { field: 'sContra', header: 'Sub Cuenta' },
    { field: 'actions', header: 'Acciones' }
  ];
  public dataSource: any = [];
  public loading: boolean = true;
  public globalFilterValue: string = '';

  promocion = '';
  empresa = '';
  private readonly _width: string = '1000px';
  constructor(private contabilidadService: ContabilidadService, private route: ActivatedRoute, public _dialog: MatDialog, private _swalService: SwalService) {}

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.promocion = String(routeParams.get('promocion'));
    this.empresa = String(routeParams.get('empresa'));
    this.getDataSource();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goBack() {
    window.history.back();
  }

  getDataSource() {
    this.contabilidadService.getAll(this.promocion).subscribe((res) => {
      this.dataSource = res;
      this.loading = false;
    });
  }

  add() {
    const dialogRef = this._dialog.open(ContabilidadFormComponent, {
      width: this._width,
      data: {
        promocion: this.promocion,
        empresa: this.empresa
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.getDataSource();
    });
  }

  deleteM(model: Contabilidad) {
    Swal.fire({
      title: 'Eliminar registro',
      text: '¿Estas seguro de eliminar el registro?',
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#d33',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        model.sPromocion = this.promocion;
        this.contabilidadService.eliminar(model).subscribe((res) => {
          if (res) this._swalService.success('Eliminado');
          else this._swalService.error('No se pudo eliminar');
          this.getDataSource();
        });
      }
    });
  }

  edit(model: Contabilidad) {
    model.sPromocion = this.promocion;
    const dialogRef = this._dialog.open(ContabilidadFormComponent, {
      width: this._width,
      data: {
        data: model,
        promocion: this.promocion,
        empresa: this.empresa
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDataSource();
    });
  }
}
